export const REGION_SOUTHERN_CALIFORNIA =
  "9014dcf2-3a69-4bee-91ac-ea44735cd4c9";
export const REGION_NORTHERN_CALIFORNIA =
  "b37edbd1-1d8b-4f94-8597-a67b90897bc9";
export const REGION_SOUTH_FLORIDA = "a30244a8-78e3-40bf-a3a2-f91963c60b1c";

export const Regions = [
  REGION_SOUTHERN_CALIFORNIA,
  REGION_NORTHERN_CALIFORNIA,
  REGION_SOUTH_FLORIDA
];
